import { useDispatch, useSelector } from "react-redux";
import {
  addClasses,
  deleteClasses,
  getActiveClass,
  getClasses,
  updateClasses,
  setActiveClasses,
} from "../store/classes";

export default function useMyClass() {
  const dispatch = useDispatch();
  const classData = useSelector((state) => state.myClass.data);
  const activeClass = useSelector((state) => state.myClass.activeClass);
  const loading = useSelector((state) => state.myClass.loading);
  const uploadLoading = useSelector((state) => state.myClass.upload.loading);

  const addClassesAction = (params) => dispatch(addClasses(params));
  const updateClassesAction = (params) => dispatch(updateClasses(params));
  const getClassesAction = (params) => dispatch(getClasses(params));
  const deleteClassesAction = (params) => dispatch(deleteClasses(params));
  const getActiveClassAction = (params) => dispatch(getActiveClass(params));
  const setActiveClassesAction = (params) => dispatch(setActiveClasses(params));
  return {
    classData,
    activeClass,
    loading,
    uploadLoading,
    addClassesAction,
    updateClassesAction,
    getClassesAction,
    deleteClassesAction,
    getActiveClassAction,
    setActiveClassesAction,
  };
}
